import React, { useState, useEffect } from 'react';
import ClipLoader from "react-spinners/ClipLoader";
import Comm from '../comm/comm';
import { toast } from 'react-toastify';
import ModalUpload from '../controls/ModalUpload';
import ModalSelectDocument from '../controls/ModalSelectDocument';
import Tools from '../tools/tools';
import { Dialog } from 'primereact/dialog';


const ModalMail = (props) => {
    let [text, setText] = useState();
    let [receiver, setReceiver] = useState();
    let [attachments, setAttachments] = useState([]);
    let [fileModalVisible, setfileModalVisible] = useState(false);

    useEffect(() => {

    }, []);

    const attach = (val) => {
        setfileModalVisible(false);
        if (val) {
            var d = attachments;
            d.push(val);
            setAttachments([...d]);
        }
    };

    const del = (id) => {
        var d = attachments;
        d = d.filter(x => x.documentId !== id);
        setAttachments([...d]);
    }

    const send = () => {

        if ((text || "") === "") {
            toast.error("Моля, въведете текст на съобщението");
            return;
        }
        if (!Tools.ValidateEmail(receiver)) {
            toast.error("Моля, въведете коректен адрес на получател");
            return;
        }
        var data = {
            requestId: parseInt(props.requestId),
            receiver: receiver,
            body: text,
            attachments: attachments.map(i => i)
        }
        Comm.Instance().post("email", data).then(r => props.closeFunc(true)).catch(error => Tools.ProcessError(error));
        
    }



    return (
        <Dialog header="Ново писмо" visible={props.display} style={{ width: '50vw' }} footer="" onHide={() => props.closeFunc(null)}>
            <div className="container">
                <h2 className="appeal-title mb-5">Заявление за издаване на удостоверение за статут по реда на ЗКН</h2>
                <div className="form-row">
                    <div className="form-group col-md-12">
                        <label>Получател</label>
                        <input type="text" className="form-control" value={receiver} onChange={(e) => setReceiver(e.target.value)} />

                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group col-md-12">
                        <label>Текст</label>
                        <textarea className="form-control" value={text} onChange={(e) => setText(e.target.value)} rows="10" />

                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group col-md-12">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th>
                                        Документ <button type="button" className="btn btn-primary" onClick={() => setfileModalVisible(true)}>Нов прикачен документ</button>
                                    </th>
                                    <th>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    attachments.map(i =>
                                        <tr key={i.documentId}>
                                            <td>
                                                <a href={'documentcontent?documentId=' + i.documentId} title={i.remark} alt={i.remark}>{i.title}</a>

                                            </td>
                                            <td>
                                                <button className="btn btn-danger" onClick={() => del(i.documentId)}>Премахване</button>
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <ModalSelectDocument display={fileModalVisible} closeFunc={(val) => attach(val)} requestId={props.requestId} />

            <div className="container">
                <button type="button" className="btn btn-primary" onClick={() => send()}>Изпращане</button>
            </div>

        </Dialog>

    );
}


export default ModalMail;

